import { ModalContent, ModalFooter, ModalHeader } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

import { FeedbackAlert } from '@/components';
import { StyledModal } from '@/styles.ts';
import { ModalControllerType } from '@/types.ts';

import { useOrbitOneCamerasForNode } from '../liceCountWidget/liceCountWidget.hooks.ts';
import { OrbitOneGalleryContext } from './orbitOneImageGalleryModal/orbitOneImageGalleryModal.types.ts';
import { OrbitOneImageGalleryModalContent } from './orbitOneImageGalleryModal/OrbitOneImageGalleryModalContent.tsx';

interface OrbitOneImageGalleryModalProps {
  /** Inventory id of the node backing the configured sensor. */
  inventoryId: string;
  galleryContext: OrbitOneGalleryContext;
  modalController: ModalControllerType;
}

export const OrbitOneImageGalleryModal = ({
  inventoryId,
  galleryContext,
  modalController,
}: OrbitOneImageGalleryModalProps) => {
  const { t } = useTranslation(['common', 'orbitOne', 'cameraControl']);
  const { orbitOneCameras, isError, isLoading, error } = useOrbitOneCamerasForNode(inventoryId);
  const titleKey =
    galleryContext === OrbitOneGalleryContext.Welfare
      ? 'orbitOne:welfare.imageGallery.title'
      : 'orbitOne:liceCount.imageGallery.title';

  return (
    <StyledModal
      open={modalController.open}
      onClose={modalController.onClose}
      closeOnEscapeClick={true}
      closeOnBackdropClick={true}
      $width={'90vw'}
      $maxWidth={'100rem'}
      height={'100vh'}
      maxHeight={'100vh'}
      style={{ marginTop: 0 }}
    >
      <ModalHeader title={t(titleKey)} onClose={modalController.onClose} />
      <ModalContent p={'0'}>
        {(isError || isLoading) && (
          <FeedbackAlert
            loading={isLoading}
            variant={'critical'}
            text={`${t('cameraControl:cannotFetchCameras')}${error ? ': ' + error.message : ''}`}
          />
        )}
        <OrbitOneImageGalleryModalContent
          cameras={orbitOneCameras}
          galleryContext={galleryContext}
        />
      </ModalContent>
      <ModalFooter
        actionButtons={[{ label: t('common:close'), onClick: modalController.onClose }]}
      />
    </StyledModal>
  );
};
